/*eslint-disable*/
// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Chip, IconButton, Tooltip, Button } from "@mui/material";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { formatDate } from "../../utils";
import { Card, RenderIf, Modal } from "@adl/smart-ui-library";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "@/hooks";
import {
  setSelectedDocument,
} from "@/redux/casesSlice";
import EditIcon from '@mui/icons-material/Edit';

type Props = {
  data: any;
  title: any;
  onSelect: (data: any) => void;
  onDeleteFile?: (id: string | number) => void;
};

const UploadedCard = ({ data, onSelect, onDeleteFile, title }: Props) => {
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const editItem = () => {
    appDispatch(setSelectedDocument(data));
    navigate(`/edit`);
  };
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);

  const date = new Date(data.createdAt).toISOString().split("T")[0];

  const deleteItem = () => {
    onDeleteFile(data.documentId);
    setDeleteModalOpen(false);
    navigate(`/non-p-code`);
  };

  const accessLevel = JSON.parse(sessionStorage.getItem('accessLevel')) || {};

  const Actions = () => (
    <>
      <RenderIf isTrue={false}>
        <Tooltip title="Preview" arrow>
          <IconButton size="small">
            <PreviewOutlinedIcon />
          </IconButton>
        </Tooltip>
      </RenderIf>
      <RenderIf isTrue={false}>
        <Tooltip title="Download" arrow>
          <IconButton size="small">
            <FileDownloadOutlinedIcon />
          </IconButton>
        </Tooltip>
      </RenderIf>
      <>
        <RenderIf isTrue={(title && accessLevel?.canEditOwn) || accessLevel?.canEditAll}>
          <Tooltip title="Edit File" arrow>
            <IconButton onClick={() => editItem()}>
              <EditIcon />
            </IconButton>

          </Tooltip>
        </RenderIf>
        <RenderIf isTrue={(title && accessLevel?.canEditOwn) || accessLevel?.canEditAll}>


          <Tooltip title="Delete File" arrow style={{ color: 'red' }}>
            <IconButton
              size="small"
              onClick={() => setDeleteModalOpen(true)}
            >
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </RenderIf>
      </>
    </>
  );

  return (
    <Card actions={<Actions />}>
      <Card.Title
        onClick={() => {
          appDispatch(setSelectedDocument(data));

          onSelect(data);
          const currentPath = location.pathname;
          navigate(`${currentPath}/document/${data.documentId}`);
        }}
      >
        {data.fileNameOriginal || "Original File Name"}
      </Card.Title>
      <Card.Categories>
        <Chip
          variant="outlined"
          label={`Document Category: ${data.category[0]?.categoryName}`}
        />



        <Chip variant="outlined" label={`Uploaded date: ${formatDate(date)}`} />
        <br />
        <div style={{ width: '100%', fontSize: '14px' }}>
          <span>Market:</span>
          <>
            {data.markets.slice(0, 3).map((item, index) => (
              <span
                key={index}
                style={{
                  borderRadius: '5px',
                  background: '#eee',
                  margin: '5px',
                  padding: '5px',
                  display: 'inline-block'
                }}
              >
                {item.market}
              </span>
            ))}
            {data.markets.length > 3 && (
              <span style={{
                borderRadius: '5px',
                background: '#eee',
                margin: '5px',
                padding: '5px',
                display: 'inline-block'
              }}>
                +{data.markets.length - 3}
              </span>
            )}
          </> 
          {data?.accountIndustry &&
          <><span>Account industry:</span>
          <span style={{ borderRadius: '5px', background: '#eee', margin: '5px', padding: '5px' }}>{data?.accountIndustry}</span>
          </>}
        </div>
      </Card.Categories>
      <Modal open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} name="quick-approval-confirmation">
        <Modal.Header>Delete Document</Modal.Header>
        <Modal.Content>
          <div>
            <div>
              <p>
                {`Are you sure you want to delete '${data.fileNameOriginal}'?
                    This action cannot be undone.`}
              </p>
            </div>

          </div>
        </Modal.Content>
        <Modal.Footer>
          <Button
            variant="outlined"
            disableElevation
            onClick={() => setDeleteModalOpen(false)}
            sx={{ width: "100%" }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            disableElevation
            style={{ background: 'red' }}
            onClick={deleteItem}
            sx={{ width: "100%" }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default UploadedCard;
